// const _import = require("@/libs/util.import." + process.env.NODE_ENV)
// export const routerName = {}
const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  904: {
    path: "/orderManage",
    name: "orderManage",
    meta: {
      title: "订单管理",
      authId: "904",
      parentId: "1",
      cache: false
    }
  },
  90401: {
    path: "/orderList",
    name: "orderList",
    meta: {
      title: "订单列表",
      authId: "90401",
      parentId: "904",
      cache: false
    },
    auth: [
      // 精品升级
      {
        authId: "9040101",
        parentId: "90401",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9040102",
        parentId: "90401",
        label: "待补录订单",
        category: "Button",
        type: "primary",
        handle: "handlMakeUpOrder",
        addRoutePath: [
          {
            authId: "90402",
            name: "补录订单",
            parentId: "90401"
          }
        ]
      },
      {
        authId: "9040103",
        parentId: "90401",
        label: "导入订单",
        category: "Button",
        type: "primary",
        handle: "handleImport"
      },
      {
        authId: "9040104",
        parentId: "90401",
        label: "查看详情",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "90403",
            name: "订单详情",
            parentId: "90401"
          }
        ]
      },
      {
        authId: "9040105",
        parentId: "90401",
        label: "发起分账",
        handle: "chooseRule"
      },
      {
        authId: "9040106",
        parentId: "90401",
        label: "分账记录",
        handle: "ruleHistory"
      },
      {
        authId: "9040107",
        parentId: "90401",
        label: "取消分账",
        handle: "cancelRule"
      },
      {
        authId: "9040108",
        parentId: "90401",
        label: "标记退款",
        category: "Button",
        type: "primary",
        handle: "signRefund"
      },
      // 次新车转化
      {
        authId: "9040109",
        parentId: "90401",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9040110",
        parentId: "90401",
        label: "确认补录",
        handle: "record"
      },
      {
        authId: "9040111",
        parentId: "90401",
        label: "取消关联",
        handle: "cancelRelat"
      },
      {
        authId: "9040112",
        parentId: "90401",
        label: "订单核销",
        handle: "writeOff"
      },
      {
        authId: "9040113",
        parentId: "90401",
        label: "退款",
        handle: "setRefund"
      },
      {
        authId: "9040114",
        parentId: "90401",
        label: "发起分账",
        handle: "chooseRule"
      },
      {
        authId: "9040115",
        parentId: "90401",
        label: "分账记录",
        handle: "ruleHistory"
      },
      {
        authId: "9040116",
        parentId: "90401",
        label: "取消分账",
        handle: "cancelRule"
      },
      {
        authId: "9040117",
        parentId: "90401",
        label: "标记退款",
        category: "Button",
        type: "primary",
        handle: "signRefund"
      },
      {
        authId: "9040118",
        parentId: "90401",
        label: "查看订单",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "90404",
            name: "查看订单",
            parentId: "90401"
          }
        ]
      },
      // 售后众筹
      {
        authId: "9040119",
        parentId: "90401",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9040120",
        parentId: "90401",
        label: "导入对账单",
        category: "Button",
        type: "primary",
        handle: "handlebillImport"
      },
      {
        authId: "9040121",
        parentId: "90401",
        label: "查看订单",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "90405",
            name: "查看订单",
            parentId: "90401"
          }
        ]
      },
      {
        authId: "9040122",
        parentId: "90401",
        label: "设为已完结",
        handle: "handleEnd"
      },
      {
        authId: "9040123",
        parentId: "90401",
        label: "确认补录",
        handle: "record"
      },
      {
        authId: "9040124",
        parentId: "90401",
        label: "取消关联",
        handle: "cancelRelat"
      },
      {
        authId: "9040125",
        parentId: "90401",
        label: "发起分账",
        handle: "chooseRule"
      },
      {
        authId: "9040126",
        parentId: "90401",
        label: "分账记录",
        handle: "ruleHistory"
      },
      {
        authId: "9040127",
        parentId: "90401",
        label: "取消分账",
        handle: "cancelRule"
      },
      {
        authId: "9040128",
        parentId: "90401",
        label: "标记已退款",
        handle: "refund"
      },
      // 会员权益升级
      {
        authId: "9040129",
        parentId: "90401",
        label: "驻店权益运营周报",
        category: "Button",
        type: "primary",
        handle: "handleWeekExportAnalysis"
      },
      {
        authId: "9040130",
        parentId: "90401",
        label: "分润&成本分析",
        category: "Button",
        type: "primary",
        handle: "handleExportAnalysis"
      },
      {
        authId: "9040131",
        parentId: "90401",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9040132",
        parentId: "90401",
        label: "查看详情",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "90403",
            name: "查看详情",
            parentId: "90401"
          }
        ]
      },
      {
        authId: "9040133",
        parentId: "90401",
        label: "发起分账",
        handle: "chooseRule"
      },
      {
        authId: "9040134",
        parentId: "90401",
        label: "分账记录",
        handle: "ruleHistory"
      },
      {
        authId: "9040135",
        parentId: "90401",
        label: "取消分账",
        handle: "cancelRule"
      },
      {
        authId: "9040136",
        parentId: "90401",
        label: "标记已退款",
        handle: "refund"
      },
      // 积分商城
      {
        authId: "9040137",
        parentId: "90401",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9040138",
        parentId: "90401",
        label: "确认补录",
        handle: "record"
      },
      {
        authId: "9040139",
        parentId: "90401",
        label: "取消关联",
        handle: "cancelRelat"
      },
      {
        authId: "9040140",
        parentId: "90401",
        label: "发起分账",
        handle: "chooseRule"
      },
      {
        authId: "9040141",
        parentId: "90401",
        label: "分账记录",
        handle: "ruleHistory"
      },
      {
        authId: "9040142",
        parentId: "90401",
        label: "取消分账",
        handle: "cancelRule"
      },
      {
        authId: "9040143",
        parentId: "90401",
        label: "订单核销",
        handle: "writeOff"
      },
      {
        authId: "9040144",
        parentId: "90401",
        label: "商品发货",
        handle: "handleExpressInfo"
      },
      {
        authId: "9040145",
        parentId: "90401",
        label: "标记已退款",
        handle: "refund"
      },
      {
        authId: "9040146",
        parentId: "90401",
        label: "查看详情",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "90403",
            name: "查看详情",
            parentId: "90401"
          }
        ]
      }
    ],
    component: _import("orderManage/orderList")
  },
  90402: {
    path: "/orderSupplement",
    name: "orderSupplement",
    meta: {
      title: "订单补录",
      authId: "90402",
      parentId: "90401",
      cache: false,
      activePath: "/orderList"
    },
    auth: [
      {
        authId: "9040201",
        parentId: "90402",
        label: "批量修改所属服务对接",
        category: "Button",
        type: "primary",
        handle: "batchUpdateYqMerchant"
      },
      {
        authId: "9040202",
        parentId: "90402",
        label: "批量标记为无需补录",
        category: "Button",
        type: "primary",
        handle: "batchMarkAsNoUse"
      },
      {
        authId: "9040203",
        parentId: "90402",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9040204",
        parentId: "90402",
        label: "订单详情",
        handle: "orderDetail"
      },
      {
        authId: "9040205",
        parentId: "90402",
        label: "发起退款",
        category: "Button",
        type: "primary",
        handle: "batchRefund"
      }
    ],
    component: _import("orderManage/orderSupplement")
  },
  90403: {
    path: "/orderDetail",
    name: "orderDetail",
    meta: {
      title: "订单详情", // 精品升级/会员权益升级
      authId: "90403",
      parentId: "90401",
      cache: false,
      activePath: "/orderList"
    },
    auth: [
      {
        authId: "9040301",
        parentId: "90403",
        label: "标记已开票", // 精品升级
        category: "Button",
        type: "primary"
      },
      {
        authId: "9040302",
        parentId: "90403",
        label: "标记已开票", // 会员权益升级
        category: "Button",
        type: "primary"
      },
      {
        authId: "9040303",
        parentId: "90403",
        label: "编辑", // 编辑备注信息
        category: "Button",
        type: "primary"
      }
    ],
    component: _import("orderManage/orderDetail")
  },
  90404: {
    path: "/configUpgradationDetail",
    name: "configUpgradationDetail",
    meta: {
      title: "查看订单", // 次新车转化
      authId: "90404",
      parentId: "90401",
      cache: false,
      activePath: "/orderList"
    },
    component: _import("orderManage/configUpgradationDetail")
  },
  90405: {
    path: "/crowdfundDetail",
    name: "crowdfundDetail",
    meta: {
      title: "查看订单", // 售后众筹
      authId: "90405",
      parentId: "90401",
      cache: false,
      activePath: "/orderList"
    },
    component: _import("orderManage/crowdfundDetail")
  },
  90406: {
    path: "/vehicleDamageTabList",
    name: "vehicleDamageTabList",
    // path: "/vehicleDamageList",
    // name: "vehicleDamageList",
    meta: {
      title: "车损报价单",
      authId: "90406",
      parentId: "904",
      cache: false
    },
    auth: [
      {
        authId: "9040601",
        parentId: "90406",
        label: "查看",
        handle: "handleDetail"
      },
      {
        authId: "9040602",
        parentId: "90406",
        label: "详情",
        handle: "handleView",
        addRoutePath: [
          {
            authId: "9040604",
            name: "查看详情",
            parentId: "90406"
          }
        ]
      },
      {
        authId: "9040603",
        parentId: "90406",
        label: "打印",
        handle: "handlePrint",
        ruleObj: {
          attr: "mode",
          rule: {
            0: "打印",
            1: "打印"
          },
          disabledStatusList: [1]
        }
      },
      {
        authId: "9040605",
        parentId: "90406",
        label: "打印合同",
        handle: "handlePrintContract"
      },
      {
        authId: "9040606",
        parentId: "90406",
        label: "新建任务",
        category: "Button",
        type: "primary",
        handle: "newTask"
      },
      {
        authId: "9040607",
        parentId: "90406",
        label: "下载模板",
        category: "Button",
        type: "primary",
        handle: "downloadTemplate"
      },
      {
        authId: "9040608",
        parentId: "90406",
        label: "详情",
        addRoutePath: [
          {
            authId: "9040611",
            name: "vehicleDamageOderImportDetail",
            parentId: "90406"
          }
        ],
        handle: "viewDetail"
      },
      {
        authId: "9040609",
        parentId: "90406",
        label: "导入",
        // handle: "importCurrentData"
        handle: "handleImportRest"
      },
      {
        authId: "90406010",
        parentId: "90406",
        label: "下载错误数据",
        handle: "downloadIncorrectData"
      }
    ],
    component: _import("vehicleDamage/vehicleDamageTabList")
  },
  9040604: {
    path: "/vehicleDamageDetail",
    name: "vehicleDamageDetail",
    meta: {
      title: "报价单详情",
      authId: "9040604",
      parentId: "90406",
      cache: false,
      activePath: "/vehicleDamageList"
    },
    component: _import("vehicleDamage/vehicleDamageDetail")
  },
  9040611: {
    path: "/vehicleDamageOderImportDetail",
    name: "vehicleDamageOderImportDetail",
    meta: {
      title: "详情",
      authId: "9040611",
      parentId: "90406",
      cache: false,
      activePath: "/vehicleDamageOderImportDetail"
    },
    component: _import("vehicleDamage/vehicleDamageOderImportDetail")
  },
  90407: {
    path: "/configUpgradationDetail",
    name: "configUpgradationDetail",
    meta: {
      title: "查看订单", // 积分商城
      authId: "90407",
      parentId: "90401",
      cache: false,
      activePath: "/orderList"
    },
    component: _import("orderManage/configUpgradationDetail")
  },
  90408: {
    path: "/refundExamine",
    name: "refundExamine",
    meta: {
      title: "退款审核",
      authId: "90408",
      parentId: "904",
      cache: false
    },
    auth: [
      {
        authId: "9040809",
        parentId: "90408",
        label: "批量运营审核",
        category: "Button",
        type: "primary",
        handle: "batchOperatorAudit"
      },
      {
        authId: "9040801",
        parentId: "90408",
        label: "批量商务审核",
        category: "Button",
        type: "primary",
        handle: "batchBusinessExamine"
      },
      {
        authId: "9040802",
        parentId: "90408",
        label: "批量财务复核",
        category: "Button",
        type: "primary",
        handle: "batchFinanceExamine"
      },
      {
        authId: "9040803",
        parentId: "90408",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9040804",
        parentId: "90408",
        label: "查看",
        handle: "handleDetail"
      },
      {
        authId: "9040805",
        parentId: "90408",
        label: "审核",
        handle: "handleExamine"
      },
      {
        authId: "9040806",
        parentId: "90408",
        label: "结算",
        handle: "handleSettlement"
      },
      {
        authId: "9040807",
        parentId: "90408",
        label: "驳回",
        handle: "handleReject"
      },
      {
        authId: "9040808",
        parentId: "90408",
        label: "下载",
        handle: "handleDownload"
      }
    ],
    component: _import("orderManage/refundExamine")
  }
}
